import { render } from "./Lejarlv2.vue?vue&type=template&id=867d2c52"
import script from "./Lejarlv2.vue?vue&type=script&lang=js"
export * from "./Lejarlv2.vue?vue&type=script&lang=js"

import "./Lejarlv2.vue?vue&type=style&index=0&id=867d2c52&lang=css"
import "./Lejarlv2.vue?vue&type=style&index=1&id=867d2c52&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__